import React, { Component } from 'react';

import TableTile from './TableTile';
import { STATUS, STATUS_LABEL } from './mockFloorPlanData';

// Only the two statuses real data can actually produce today — QR/Booking/
// Reserved stay defined in mockFloorPlanData for later, but showing them in
// the legend now would promise a filter/state nothing behind this screen can
// produce yet. See API_MAPPING.md.
const LEGEND_ORDER = [STATUS.AVAILABLE, STATUS.PROGRESS];

class FloorPlan extends Component {

    render() {
        const { tables, selectedTableId, onTableSelect } = this.props;

        if (!tables || tables.length === 0) {
            return (
                <div className="captain-floor">
                    <div className="captain-empty">No tables found.</div>
                </div>
            );
        }

        return (
            <div className="captain-floor">

                <div className="captain-floor-grid">
                    {tables.map(table => (
                        <TableTile
                            key={table.id}
                            table={table}
                            selected={selectedTableId === table.id}
                            onClick={onTableSelect}
                        />
                    ))}
                </div>

                <div className="captain-legend">
                    {LEGEND_ORDER.map(status => (
                        <div className="captain-legend-item" key={status}>
                            <span className={`captain-legend-dot captain-legend-dot--${status}`} />
                            {STATUS_LABEL[status]}
                        </div>
                    ))}
                </div>

            </div>
        );
    }
}

export default FloorPlan;
